export function arrayPrototypeMutations() {
  /*******************************************************************************
   * Array.prototype.find */
  /**
   * @ngdoc    method
   * @name     find
   * @methodOf polyfill.Array
   * @description
   * see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
   *******************************************************************************/
  // if (!Array.prototype.find)
  //   {
  //   Object.defineProperty(Array.prototype, 'find',
  //     {
  //     value: function(predicate)
  //       {
  //      // 1. Let O be ? ToObject(this value).
  //       if (this == null) { throw new TypeError('"this" is null or not defined'); }

  //       var o = Object(this);

  //       // 2. Let len be ? ToLength(? Get(O, "length")).
  //       var len = o.length >>> 0;

  //       // 3. If IsCallable(predicate) is false, throw a TypeError exception.
  //       if (typeof predicate !== 'function') { throw new TypeError('predicate must be a function'); }

  //       // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
  //       var thisArg = arguments[1];

  //       // 5. Let k be 0.
  //       var k = 0;

  //       // 6. Repeat, while k < len
  //       while (k < len)
  //         {
  //         // a. Let Pk be ! ToString(k).
  //         // b. Let kValue be ? Get(O, Pk).
  //         // c. Let testResult be ToBoolean(? Call(predicate, T, � kValue, k, O �)).
  //         // d. If testResult is true, return kValue.
  //         var kValue = o[k];
  //         if (predicate.call(thisArg, kValue, k, o)) { return kValue; }
  //         // e. Increase k by 1.
  //         k++;
  //         }

  //       // 7. Return undefined.
  //       return undefined;
  //       }
  //     });
  //   }

  /*****************************************************************************
   * Array.prototype.removeItem */
  /**
   * @ngdoc    method
   * @name     removeItem
   * @methodOf polyfill.Array
   * @param    {object}  item  Item to remove
   * @returns  {boolean} True=Removed. False=Item not found
   * @description
   * Removes `item` from the array.
   *****************************************************************************/
  Array.prototype.removeItem = function (item) {
    var idx = this.indexOf(item);

    if (idx == -1) return false;
    else return this.splice(idx, 1), true;
  };

  /*****************************************************************************
   * Array.prototype.sortOn */
  /**
   * @ngdoc    method
   * @name     sortOn
   * @methodOf polyfill.Array
   * @param    {string...} arg  Property names to sort against.
   * @returns  {Array}     Sorted array.
   * @description
   * Enhance the Array prototype to sort on a specified property name matching
   * the arguments in order. If any property does not exist on the objects,
   * skip that sort check.
   *
   * Sort options can be added after the property using the pipe ("|") character.
   * Options that will change from standard sort are:
   *   DESC  - Sort in descending order
   *   NCASE - Sort without case-sensitivity.
   *
   * These options allow for sorting by multiple fields, and applies more
   * granularity with how to make those sorts.
   *
   * e.g.: .sortOn('letter|NCASE','index|DESC') will sort a list of objects first
   * the property "letter" ignoring case, then if there is a duplication, it will
   * sort by "index" in descending order.
   *****************************************************************************/
  Array.prototype.sortOn = function (arg) {
    /*------------------------------------------------*/
    /* If no parameters were passed in, just return   */
    /* the original array, using the default sorting. */
    /*------------------------------------------------*/
    if (arguments.length == 0) return this.sort();

    /*--------------------------------------------*/
    /* Make sure that we are working with an      */
    /* array of parameters by converting a single */
    /* parameter to an array of one element.      */
    /*--------------------------------------------*/
    var args = arguments.length == 1 ? [arg] : arguments;
    var thisArr = this;

    /*-----------------------------*/
    /* Sort against each property. */
    /*-----------------------------*/
    thisArr = thisArr.sort(function (o1, o2) {
      var diff = 0;

      for (var i = 0; i < args.length; i++) {
        var prop = args[i].split('|')[0];
        var options = args[i].split('|').slice(1);
        var direction = 1;
        var caseSensitive = true;

        options.forEach(function (option) {
          if (option.trim() == 'DESC') direction = -1;
          else if (option.trim() == 'NCASE') caseSensitive = false;
        });

        /*------------------------------------------------------------*/
        /* Make sure the properties to sort against are available,    */
        /* otherwise, return a default sorting of the original array. */
        /*------------------------------------------------------------*/
        var propPath = (prop || '').trim();
        if (!propPath || propPath.length == 0) return this.sort();

        var v1 = getValueFromObjectPath(o1, propPath);
        var v2 = getValueFromObjectPath(o2, propPath);

        if (
          typeof v1 === 'string' &&
          typeof v2 === 'string' &&
          !caseSensitive
        ) {
          v1 = v1.toUpperCase();
          v2 = v2.toUpperCase();
        }

        if (v1 != v2) {
          diff = (v1 < v2 ? -1 : 1) * direction;
          break;
        }
      }

      return diff;
    });

    return thisArr;

    /*---------------------------------------------------------------------------*/
    /* getValueFromObjectPath                                                    */
    /*                                                                           */
    /* Recursively traverses the <b>obj</b> for the value at the <b>path</b>     */
    /* location.                                                                 */
    /*                                                                           */
    /* @param   obj   Object the contains the value and its path.                */
    /* @param   path  Path where the value is located.                           */
    /* @returns       The value at the end of the <b>path</b> of the <b>obj</b>, */
    /*                or the first <c>undefined</c> or <c>null</c> value.        */
    /*---------------------------------------------------------------------------*/
    function getValueFromObjectPath(obj, path) {
      path = (path || '').trim();

      if (obj && path.length > 0) {
        var paths = path.split('.');
        obj = getValueFromObjectPath(obj[paths.shift()], paths.join('.'));
      }
      return obj;
    }
  };
}
